import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';




// Páginas auth
import LoginPage          from './pages/auth/LoginPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage  from './pages/auth/ResetPasswordPage';

// Páginas principales
import DashboardPage            from './pages/dashboard/DashboardPage';
import ComprobantesPage         from './pages/comprobantes/ComprobantesPage';
import IngresosPage             from './pages/ingresos/IngresosPage';
import GastosPage               from './pages/gastos/GastosPage';
import ProveedoresPage          from './pages/proveedores/ProveedoresPage';
import ReportesPage             from './pages/reportes/ReportesPage';
import AlertasPage              from './pages/alertas/AlertasPage';
import AsistenteAIPage          from './pages/asistente/AsistenteAIPage';

// Páginas administrador
import UsuariosPage             from './pages/usuarios/UsuariosPage';
import BackupPage               from './pages/backup/BackupPage';
import PresupuestosPage         from './pages/presupuestos/PresupuestosPage';
import CategoriasPage           from './pages/categorias/CategoriasPage';
import AuditoriaPage            from './pages/auditoria/AuditoriaPage';
import BalanceContadorPage      from './pages/balance-contador/BalanceContadorPage';
import ComprobantesContadorPage from './pages/comprobantes-contador/ComprobantesContadorPage';
import CajaChicaPage            from './pages/cajachica/CajaChicaPage';
import HonorariosPage           from './pages/honorarios/HonorariosPage';
import BeneficiosPage from './pages/planillas/BeneficiosPage';

// Páginas planillas
import EmpleadosPage from './pages/planillas/EmpleadosPage';
import AsistenciaPage from './pages/planillas/AsistenciaPage';
import NominaPage from './pages/planillas/NominaPage';

function RutaProtegida({ children }) {
  const { usuario } = useAuth();
  return usuario ? children : <Navigate to="/login" replace />;
}

function RutaPorRol({ roles, children }) {
  const { usuario } = useAuth();
  if (!usuario) return <Navigate to="/login" replace />;
  if (!roles.includes(usuario.rol)) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>

            {/* Rutas públicas */}
            <Route path="/login"           element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password"  element={<ResetPasswordPage />} />

            {/* Rutas para todos los roles autenticados */}
            <Route path="/dashboard"    element={<RutaProtegida><DashboardPage /></RutaProtegida>} />
            <Route path="/comprobantes" element={<RutaProtegida><ComprobantesPage /></RutaProtegida>} />
            <Route path="/ingresos"     element={<RutaProtegida><IngresosPage /></RutaProtegida>} />
            <Route path="/gastos"       element={<RutaProtegida><GastosPage /></RutaProtegida>} />
            <Route path="/proveedores"  element={<RutaProtegida><ProveedoresPage /></RutaProtegida>} />
            <Route path="/reportes"     element={<RutaProtegida><ReportesPage /></RutaProtegida>} />
            <Route path="/alertas"      element={<RutaProtegida><AlertasPage /></RutaProtegida>} />
            <Route path="/asistente"    element={<RutaProtegida><AsistenteAIPage /></RutaProtegida>} />

            {/* Rutas solo administrador */}
            <Route path="/usuarios" element={
              <RutaPorRol roles={['administrador']}><UsuariosPage /></RutaPorRol>
            } />
            <Route path="/backup" element={
              <RutaPorRol roles={['administrador']}><BackupPage /></RutaPorRol>
            } />
            <Route path="/presupuestos" element={
              <RutaPorRol roles={['administrador']}><PresupuestosPage /></RutaPorRol>
            } />
            <Route path="/categorias" element={
              <RutaPorRol roles={['administrador']}><CategoriasPage /></RutaPorRol>
            } />
            <Route path="/auditoria" element={
              <RutaPorRol roles={['administrador']}><AuditoriaPage /></RutaPorRol>
            } />
            <Route path="/balance-contador" element={
              <RutaPorRol roles={['administrador']}><BalanceContadorPage /></RutaPorRol>
            } />
            <Route path="/comprobantes-contador" element={
              <RutaPorRol roles={['administrador']}><ComprobantesContadorPage /></RutaPorRol>
            } />
            <Route path="/caja-chica" element={
              <RutaPorRol roles={['administrador']}><CajaChicaPage /></RutaPorRol>
            } />
            <Route path="/honorarios" element={
              <RutaPorRol roles={['administrador']}><HonorariosPage /></RutaPorRol>
            } />

            {/* Rutas planillas */}
            <Route path="/planillas/empleados" element={
              <RutaPorRol roles={['administrador']}><EmpleadosPage /></RutaPorRol>
            } />
            <Route path="/planillas/asistencia" element={
              <RutaPorRol roles={['administrador']}><AsistenciaPage /></RutaPorRol>
            } />
            <Route path="/planillas/nomina" element={
              <RutaPorRol roles={['administrador']}><NominaPage /></RutaPorRol>
            } />
            <Route path="/planillas/beneficios" element={
              <RutaPorRol roles={['administrador']}><BeneficiosPage /></RutaPorRol>
            } />

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}